
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Corporatecabserviceinpune() {



  const cardData =
  {
    keyword: '  Corporate Cab Service in Pune',
    heading: 'Vaishnavi Travels: Corporate Cab Service in Pune',
    headingDescription: 'Vaishnavi Travels provides premium and dependable Corporate Cab Service in Pune, designed for companies, guests, and business travelers. Our cabs are well-maintained with spacious seating, strong air-conditioning, and ample luggage space, ensuring every ride is comfortable and professional. With experienced chauffeurs, punctual pickups, and flexible booking plans, we make your corporate travel smooth and hassle-free. Whether it’s daily employee commutes, airport transfers, client meetings, or corporate events, Vaishnavi Travels guarantees reliable, stylish, and efficient cab service in Pune.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s grand fort palace and a symbol of Maratha pride. Once the seat of the Maratha Empire, its massive gates, fountains, and courtyards echo with history. Though partially destroyed by fire in 1828, it still draws thousands of visitors daily. The evening light-and-sound show brings alive tales of Bajirao and Mastani. Tourists love exploring its hidden pathways and gardens. Shaniwar Wada is Pune’s crown jewel of heritage and culture."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a monument of national importance linked to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. Today, it houses a museum showcasing Gandhi’s personal belongings, photographs, and letters. Its Italian arches and landscaped gardens add serene charm. Students and tourists find it both inspirational and peaceful. Aga Khan Palace is Pune’s proud landmark of patriotism and sacrifice."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is a hilltop stronghold known for the 1670 battle where Tanaji Malusare fought for Chhatrapati Shivaji Maharaj. Trekkers climb to the fort for stunning views of the Sahyadris. The fort still has bastions, temples, and memorials that narrate Maratha valor. In monsoon, mist and waterfalls make the climb enchanting. Local stalls serve rustic pithla-bhakri to visitors. Sinhagad Fort is Pune’s mix of history, trekking, and scenic charm."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous shrine dedicated to Lord Ganesha. The grand idol, adorned with gold and jewels, attracts lakhs of devotees every year. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. Known for its cultural and charitable contributions, it blends faith with service. Devotees feel immense spiritual energy here. Dagdusheth Temple is Pune’s divine and cultural heartbeat."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, carved in the 8th century, is an ancient rock-cut shrine dedicated to Lord Shiva. Massive stone pillars, a sanctum, and a Nandi mandapa highlight its architecture. Despite being in the city center, it offers peace and meditation. Evening chants add to its spiritual aura. History lovers admire its craftsmanship and simplicity. Pataleshwar Cave Temple is Pune’s hidden spiritual heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure housing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, sculptures, musical instruments, and everyday antiques. A highlight is the recreated Mastani Mahal, reflecting Maratha romance and history. Students and tourists find the museum highly educational. It preserves centuries of Indian traditions in one place. Raja Dinkar Kelkar Museum is Pune’s proud showcase of culture and art."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop temple complex is dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Smaller shrines and a museum nearby add cultural depth. Pilgrims climb 103 steps to reach the temple, blending devotion with scenic charm. Sunrise and sunset views here are captivating. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub for wellness and spirituality. Spread across serene gardens, it attracts seekers from around the world. Meditation sessions, yoga practices, and workshops on personal growth are conducted here. Its Zen gardens and tranquil halls enhance the experience. Beyond spirituality, it is also a rejuvenation retreat. Osho Ashram is Pune’s international destination for peace and mindfulness."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, also known as the Okayama Friendship Garden, is Pune’s largest landscaped park. Inspired by Japan’s Korakuen Garden, it features streams, bridges, and manicured lawns. Families enjoy picnics, photography, and peaceful walks here. Seasonal flowers and greenery add vibrant charm. It also symbolizes Indo-Japanese friendship. Pu La Deshpande Garden is Pune’s green paradise of tranquility."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend retreat near Pune. It supplies water to the city while offering scenic backdrops of hills and flowing waters. During monsoon, the overflowing dam creates a mesmerizing sight. Families gather here for roasted corn and tea at roadside stalls. It also serves as the gateway to Sinhagad Fort. Khadakwasla Dam is Pune’s refreshing natural escape."
  }
],


    "services": [
    {
      "name": "Corporate Taxi Hire Pune",
      "description": "Professional corporate taxi hire services in Pune designed to cater to business travel needs with reliability and comfort. Whether for daily employee commutes, client pickups, or executive transport, these services offer a fleet of well-maintained vehicles and experienced drivers who ensure timely and professional service, helping companies streamline their transportation logistics efficiently."
    },
    {
      "name": "Staff Transportation Service Pune",
      "description": "Comprehensive staff transportation solutions tailored for Pune-based companies, ensuring safe, punctual, and comfortable travel for employees. Our services include pick-up and drop-off scheduling, route optimization, and regular vehicle maintenance to provide hassle-free commutes that boost workforce productivity and satisfaction."
    },
    {
      "name": "Corporate Outstation Cab Pune",
      "description": "Reliable outstation corporate cab services from Pune, ideal for business trips, client visits, or corporate retreats. These services provide flexible booking options, comfortable vehicles including AC and non-AC options, and experienced drivers familiar with major routes, ensuring efficient and stress-free long-distance corporate travel."
    },
    {
      "name": "AC Corporate Cab Service",
      "description": "Comfortable and climate-controlled AC corporate cab services in Pune designed for executive travel and employee transportation. These vehicles come with plush interiors, cleanliness standards, and professional chauffeurs who prioritize comfort and professionalism, making every business journey smooth and pleasant regardless of Pune’s weather conditions."
    },
    {
      "name": "Non AC Staff Cab Pune",
      "description": "Affordable non-AC staff cab options in Pune for corporate clients seeking budget-friendly employee transport solutions. These vehicles are well-maintained, safe, and reliable, providing practical commuting options for companies looking to optimize costs while ensuring staff reach work on time and comfortably."
    },
    {
      "name": "Airport Pickup Corporate Cab",
      "description": "Specialized airport pickup services tailored for corporate clients in Pune, ensuring timely and hassle-free arrivals and departures for executives and employees. Drivers monitor flight schedules to provide on-time pickups, assist with luggage, and maintain professional conduct, offering a seamless airport transfer experience that reflects your company’s standards."
    },
    {
      "name": "Conference/Event Cab Pune",
      "description": "Dedicated cab services for conferences, seminars, and corporate events in Pune, providing efficient transport solutions for attendees, speakers, and VIP guests. These services include bulk bookings, flexible scheduling, and reliable vehicles to ensure smooth arrivals and departures, enhancing the overall success of your business events."
    },
    {
      "name": "Monthly Corporate Cab Booking",
      "description": "Convenient monthly corporate cab booking plans for Pune businesses, offering cost-effective and streamlined employee transportation solutions. This service includes scheduled pickups, customizable routes, and regular billing, helping companies manage their transportation needs with predictability and ease."
    },
    {
      "name": "Corporate Car Pool Cab Pune",
      "description": "Eco-friendly and cost-efficient corporate car pool cab services in Pune that promote shared rides among employees commuting from similar locations. This reduces traffic congestion and carbon footprint while providing a convenient and budget-friendly option supported by reliable scheduling and comfortable vehicles."
    },
    {
      "name": "Online Corporate Taxi Service",
      "description": "Book corporate taxis in Pune easily through our secure online platform, designed for business travelers and company transport coordinators. The service offers vehicle selection, instant booking confirmation, transparent fare estimates, and 24/7 customer support, making corporate travel management simpler and more efficient."
    },
    {
      "name": "Executive Cab Service Pune",
      "description": "Premium executive cab services in Pune tailored for top-level management and VIPs requiring luxury vehicles, discreet service, and professional chauffeurs. These cabs provide enhanced comfort, privacy, and punctuality, suitable for important meetings, airport transfers, and business tours with attention to detail and superior service standards."
    },
    {
      "name": "Corporate Tour Cab Pune",
      "description": "Specialized corporate tour cab services offering comfortable and reliable transportation for business tours, client visits, and team outings in and around Pune. These cabs come with flexible itineraries, professional drivers familiar with key business hubs, and well-maintained vehicles to ensure a productive and pleasant travel experience."
    },
    {
      "name": "24/7 Corporate Cab Pune",
      "description": "Round-the-clock corporate cab services in Pune ensuring availability anytime your business needs arise, whether for late-night airport pickups, early morning meetings, or urgent travel requests. This service provides dependable vehicles and professional drivers committed to punctuality and safety, supporting seamless business operations without time constraints."
    }
  ],
  "tableData": [
    ["Corporate Taxi Hire Pune", "Staff Transportation Service Pune"],
    ["Corporate Outstation Cab Pune", "AC Corporate Cab Service"],
    ["Non AC Staff Cab Pune", "Airport Pickup Corporate Cab"],
    ["Conference/Event Cab Pune", "Monthly Corporate Cab Booking"],
    ["Corporate Car Pool Cab Pune", "Online Corporate Taxi Service"],
    ["Executive Cab Service Pune", "Corporate Tour Cab Pune"],
    ["24/7 Corporate Cab Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Pune",
    "WhyChoosedescription": "Vaishnavi Travels offers professional and reliable corporate cab services in Pune, ideal for business travel and employee transportation."
  },
  {
    "WhyChooseheading": "Wide Range of Comfortable Vehicles",
    "WhyChoosedescription": "Choose from Swift Dzire, Ertiga, Innova, Urbania, and Tempo Traveller to suit your corporate travel requirements."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Fleet",
    "WhyChoosedescription": "Our vehicles are regularly serviced and cleaned to ensure a safe and hygienic travel environment."
  },
  {
    "WhyChooseheading": "Experienced and Punctual Drivers",
    "WhyChoosedescription": "Our professional drivers are trained, courteous, and familiar with Pune’s routes for timely and smooth journeys."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "We provide all-inclusive pricing with no hidden charges, covering fuel, tolls, parking, and driver allowances."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Locations",
    "WhyChoosedescription": "Enjoy convenient door-to-door service from offices, hotels, or residences anywhere in Pune."
  },
  {
    "WhyChooseheading": "Ideal for Business Travel and Employee Commutes",
    "WhyChoosedescription": "Perfect for corporate clients looking for reliable and comfortable transportation solutions."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
    "WhyChoosedescription": "Our support team is available round-the-clock to assist with bookings, itinerary planning, and travel inquiries."
  }
]





















  }




const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels provide corporate cab services in Pune?',
      answer: 'Yes, Vaishnavi Travels offers dedicated corporate cab services in Pune, designed for employee transportation, executive travel, and client pickups with professional service and flexible billing.',
    },
    {
      question: 'What types of vehicles are available for corporate cab service?',
      answer: 'We provide a wide range of vehicles including Swift Dzire, Ertiga, Innova Crysta, and Tempo Travellers to suit individual executive travel as well as group staff transport needs.',
    },
    {
      question: 'Can I get monthly or long-term corporate cab packages?',
      answer: 'Absolutely! We offer custom monthly and long-term cab contracts for companies with fixed pricing, priority bookings, and end-of-month billing options.',
    },
    {
      question: 'Are Vaishnavi Travels drivers trained for corporate and executive travel?',
      answer: 'Yes, our drivers are well-trained in corporate etiquette, punctuality, and professional behavior. They dress appropriately and maintain high service standards.',
    },
    {
      question: 'Does Vaishnavi Travels support GST billing for corporate clients?',
      answer: 'Yes, we provide GST-compliant invoices for all corporate rides, along with consolidated monthly billing and detailed travel reports if required.',
    },
    {
      question: 'Is the corporate cab service available 24/7 in Pune?',
      answer: 'Yes, we offer round-the-clock cab services for our corporate clients, including late-night or early-morning shifts, airport drops, and intercity travel.',
    },
    {
      question: 'How can my company partner with Vaishnavi Travels for corporate transport?',
      answer: 'Simply contact our corporate service desk via phone or WhatsApp. We’ll set up a meeting, understand your requirements, and tailor a package with dedicated support and service-level agreements (SLAs).',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Prashant Naik",
    position: "HR Manager, TechCorp Pvt Ltd",
    feedback:
      "We’ve been using Vaishnavi Travels for over a year now for our corporate transportation in Pune. Their reliability, clean vehicles, and driver professionalism are unmatched. Excellent service!",
    rating: 5,
  },
  {
    name: "Ms. Rutuja Bhosale",
    position: "Admin Executive, StartupHub India",
    feedback:
      "Vaishnavi Travels handles all our employee drops and airport pickups. The monthly billing system is smooth, and the drivers are always on time. They’ve made our transport stress-free.",
    rating: 5,
    style: "style-2",
  }
];














































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];

const corporateCabServiceSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Corporate Cab Service in Pune",
  "description": "Reliable corporate cab service in Pune offering AC and Non-AC staff transportation, airport pickups, conference and event cabs, monthly bookings, and executive taxi services.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Vaishnavi Travels",
    "telephone": "+91-9765685295",
    "url": "https://vaishnavitravel.com/corporate-cab-service-pune"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "serviceType": [
    "Corporate Taxi Hire",
    "Staff Transportation Service",
    "Corporate Outstation Cab",
    "Airport Pickup Corporate Cab",
    "Conference/Event Cab",
    "Monthly Corporate Cab Booking",
    "Corporate Car Pool Cab",
    "Executive Cab Service",
    "Corporate Tour Cab",
    "24/7 Corporate Cab Service"
  ],
  "availability": "https://schema.org/InStock"
};





  return (
    <div>

<Helmet>
  <title>Corporate Cab Service in Pune | Reliable Staff Transportation</title>
  <meta
    name="description"
    content="Reliable corporate cab service in Pune offering AC and Non-AC staff transportation, airport pickups, conference and event cabs, monthly bookings, and executive taxi services."
  />
  <meta
    name="keywords"
    content="Corporate Taxi Hire Pune, Staff Transportation Service Pune, Corporate Outstation Cab Pune, AC Corporate Cab Service, Non AC Staff Cab Pune, Airport Pickup Corporate Cab, Conference Event Cab Pune, Monthly Corporate Cab Booking, Corporate Car Pool Cab Pune, Online Corporate Taxi Service, Executive Cab Service Pune, Corporate Tour Cab Pune, 24/7 Corporate Cab Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(corporateCabServiceSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/66.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinpune;